// Shared metadata for the Settings → AI Provider cards. Adding a new text
// provider is just a new entry here + a new `ai_provider` enum value +
// a case in supabase/functions/llm-utils.ts's callChatCompletion dispatcher
// — no new table, no new UI component.
export const AI_TEXT_PROVIDERS = [
  {
    value: 'openai',
    label: 'OpenAI',
    description: 'GPT models — the original provider used across Gymplix.',
    models: [
      { value: 'gpt-4o', label: 'GPT-4o' },
      { value: 'gpt-4o-mini', label: 'GPT-4o mini' },
      { value: 'gpt-4-turbo', label: 'GPT-4 Turbo' },
      { value: 'gpt-4', label: 'GPT-4' },
    ],
    defaultModel: 'gpt-4o',
    helperNote: 'A ChatGPT Plus subscription does not automatically include OpenAI API credits. Get a key at platform.openai.com.',
  },
  {
    value: 'deepseek',
    label: 'DeepSeek',
    description: 'DeepSeek-V3 and R1 — an OpenAI-compatible, cost-efficient alternative.',
    models: [
      { value: 'deepseek-chat', label: 'DeepSeek Chat (V3)' },
      { value: 'deepseek-reasoner', label: 'DeepSeek Reasoner (R1)' },
    ],
    defaultModel: 'deepseek-chat',
    helperNote: 'Get an API key at platform.deepseek.com.',
  },
  {
    value: 'anthropic',
    label: 'Claude AI',
    description: "Anthropic's Claude models.",
    models: [
      { value: 'claude-opus-5', label: 'Claude Opus 5' },
      { value: 'claude-sonnet-5', label: 'Claude Sonnet 5' },
      { value: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5' },
    ],
    defaultModel: 'claude-sonnet-5',
    helperNote: 'Get an API key at console.anthropic.com.',
  },
  {
    value: 'gemini',
    label: 'Gemini',
    description: "Google's Gemini models.",
    models: [
      { value: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro' },
      { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash' },
      { value: 'gemini-2.0-flash', label: 'Gemini 2.0 Flash' },
    ],
    defaultModel: 'gemini-2.5-flash',
    helperNote: 'Get an API key at Google AI Studio (aistudio.google.com).',
  },
];

export function getProviderConfig(value) {
  return AI_TEXT_PROVIDERS.find((p) => p.value === value) || null;
}
